import type { ComponentProps, PropsWithChildren } from "react";
import { classNames } from "../../utils/classNames";

type ContainerProps = PropsWithChildren<ComponentProps<"div">>;

export function Container({ children, className, ...props }: ContainerProps) {
  return (
    <div className="px-6 min-h-full">
      <div
        className={classNames(
          "flex flex-col flex-1 max-w-[1440px] mx-auto",
          className,
        )}
        {...props}
      >
        {children}
      </div>
    </div>
  );
}
